import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { closeModal } from '../../../actions/modalActions';
import close from '../../../assets/close-large-gray.svg';
import './dietDecideInfoCard.scss';

class DietDecideInfoCard extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="diet-decide-info-container">
                <header>
                    <h3>How to decide</h3>
                    <img className='close icon' src={close} onClick={() => this.props.closeModal()} />
                </header>

                <div className='diet-decide-info-categories'>
                    <p>
                        <strong>To achieve whole body health: </strong>
                        Choose this if your primary goal is to make healthy eating a lifestyle. 
                        We’ll show you diets that nourish your body without having to follow complicated rules.
                    </p>
                    <p>
                        <strong>To develop healthy eating habits: </strong>
                        Choose this if your primary goal is losing weight. 
                        We’ll show you diets that help you lose weight in a safe, 
                        sustainable way without crash dieting.
                    </p>
                    <p>
                        <strong>To lose weight: </strong>
                        Choose this if your primary goal is losing weight. 
                        We’ll show you diets that help you lose weight in a safe, sustainable way without crash dieting.
                    </p>
                    <p>
                        <strong>To gain weight: </strong>
                        Choose this if your primary goal is gaining weight. 
                        We’ll show you diets that help you gain weight through eating nourishing foods and exercising.
                    </p>
                </div>
            </div>
        );
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeModal: () => dispatch(closeModal())
    };
};


export default connect(null, mapDispatchToProps)(withRouter(DietDecideInfoCard));